import styles from './Eyebrow.module.scss'
import cx from 'classnames'
import { EyebrowProps } from '~types'

const Eyebrow = ({
  title,
  backgroundColor = 'transparent',
  color = 'light',
  isBold = false,
  isCornerTag = false,
  justify = 'left',
  noMarginBottom = false,
  noMarginTop = false,
  size = 'md'
}: EyebrowProps) => {
  const classNames = cx(
    styles.eyebrow,
    styles[`eyebrow--size-${size}`],
    styles[backgroundColor !== 'transparent' ? `eyebrow--has-background-color` : ''],
    styles[isBold ? `eyebrow--is-bold` : ''],
    // Global class names
    `is-color-${backgroundColor !== 'transparent' ? 'light' : color}`,
    `has-bg-color-${backgroundColor}`,
    `text-justify-${justify}`,
    noMarginBottom && 'mb-0',
    noMarginTop && 'mt-0',
    isCornerTag && styles['eyebrow--is-corner-tag']
  )

  return <h6 className={classNames}>{title}</h6>
}

export default Eyebrow
